import './contentContainer.scss'
import clsx from 'clsx'

interface ContentContainerProps extends React.HTMLAttributes<HTMLDivElement> {
    children?: React.ReactNode
    className?: string
}

export const ContentContainer = ({
    children,
    className,
    ...props
}: ContentContainerProps) => {
    return (
        <div className={clsx('content-container', className)} {...props}>
            {children}
        </div>
    )
}
